import React, {useState, useEffect} from 'react';
import Login from '../components/login';

function Home(props) {
    return (
        <> 
            <div className="login-container">
                <Login></Login>
            </div>
        </>
    );
}
export default Home;